import {Component, DestroyRef, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {Router} from '@angular/router';
import {AppStateService} from '../../services/app-state.service';
import {BottomSheetService} from '../../services/bottom-sheet.service';
import {PrebookMenu} from '../../models/Order';
import {MenuUtils} from '../../utils/Utils';

/**
 * The guest menus of a prebooking as menu cards, opened from the menu button in the bottom bar: picking one opens
 * its page.
 */
@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-prebook-menus-sheet',
  template: `
    <div class="max-w-lg mx-auto bg-theme-surface-80 pb-safe w-full">
      <div class="flex flex-col gap-3 px-4 py-6">
        @for (menu of menus; track menu.id) {
          <button class="flex items-center gap-3 text-left rounded-xl p-4 border-2 bg-theme-surface"
                  [ngClass]="menu.id === selectedPageId ? 'border-theme-secondarybutton' : 'border-theme-divider'"
                  (click)="select(menu)">
            <div class="flex-1 min-w-0">
              <div class="text-lg font-bold text-theme-text break-words">{{ menu.name }}</div>
              @if (menu.note) {
                <div class="text-base text-theme-text2 line-clamp-2">{{ menu.note }}</div>
              }
            </div>
            @if (menu.id === selectedPageId) {
              <i class="fas fa-check text-theme-text"></i>
            } @else {
              <i class="fas fa-chevron-right text-theme-text3"></i>
            }
          </button>
        }
      </div>
    </div>
  `
})
export class PrebookMenusSheetComponent implements OnInit {
  @Input() selectedPageId = '';
  menus: PrebookMenu[] = [];

  constructor(private router: Router, private appStateService: AppStateService, private sheetService: BottomSheetService,
              private destroyRef: DestroyRef) {}

  ngOnInit(): void {
    this.appStateService.observeAppState()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(appState => this.menus = MenuUtils.prebookMenus(appState));
  }

  select(menu: PrebookMenu) {
    this.sheetService.popSheet();
    this.router.navigate([this.appStateService.venueId, "menu", menu.id]);
  }
}
